import React from 'react';
import ReactDOM from 'react-dom/client';
import "@progress/kendo-theme-default";
import './index.css';
import './adventure.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);